<template>
  <div :class="[$style['pt-com-header'],'shadow']">
      <div>
        <pt-page-breadcrumb :breadcrumbArr="currentBreadcrumbs"></pt-page-breadcrumb>
        </div>
    <div :class="$style['pt-com-header__content']">
      <div :class="$style['user__content']">
        <wt-avatar size="40px"><img :src="headImg||require('@/assets/images/avatar.png')" @click="toggle()"></wt-avatar>
        <span @click="toggle()">{{this.$auth.user().fullName}}</span>
        <ul v-if="show" :class="$style['pt-com-header__content__logout']" @click="toggle()">
          <!-- <li>个人中心</li> -->
          <li @click="goEditPass">修改密码</li>
          <li @click="logout">退出登录</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ptPageBreadcrumb from 'cps/base/pt-page-breadcrumb'

import { updateBreadcrumb } from '@/utils/breadcrumb'
export default {
  name: 'pt-com-header',
  data () {
    return {
      show: false,
      menuList: [],
      headImg: (this.$auth.user() && this.$auth.user().headImage) || null
    }
  },
  components: {

    ptPageBreadcrumb
  },
  watch: {
    '$store.state.menuList': {
      handler: function (val) {
        this.menuList = val
      },
      immediate: true
    }
  },
  computed: {
    currentRotute () {
      return this.$route
    },
    isEdit () {
      return this.$route.params && this.$route.params.isEdit && this.$route.params.isEdit === 'true'
    },
    newText () {
      return this.$route.meta && this.$route.meta.newText
    },
    isForm () {
      return this.$route.meta && this.$route.meta.isForm
    },
    isExternal () {
      return this.$route.path === '/external'
    },
    isRecollect () {
      return this.$route.query.recollect === 'true'
    },
    currentBreadcrumbs () {
      return updateBreadcrumb(this.currentRotute, this.menuList, this.isForm, this.isEdit, this.newText, this.isExternal, this.isRecollect)
    }
  },
  methods: {
    toggle () {
      this.show = !this.show
    },
    logout () {
      this.$confirm('此操作将退出当前登录用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$auth.logout()
      })
    },
    goEditPass () {
      this.$router.push('/edit-password')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import '~less/var.less';
.pt-com-header{
  position: fixed;
  top:0;
  left: 240PX;
//   width: 100%-240PX;
  width:~"calc(100% - 240px)";
  height: 60PX;
  line-height: 60PX;
  background: #fff;
  // overflow-x: hidden;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  box-shadow:10px 10px 0.1rem #eee
}
.pt-com-header__content{
  display: flex;
  justify-content:flex-end;
  align-items: center;
  padding:0 40PX;
  font-size: 14px;
}
.user__content{
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  span{
    margin-left: 15px;
  }
}
.pt-com-header__content__logout{
  position: absolute;
  left: 0;
  top:100%;
  width:100%;
  color:@mainColor;
  border-top:2px solid @mainColor;
  font-size: 14px;
  line-height: 40px;
  background:#fff;
  padding-left: 10px;
  box-shadow: 0px 0px 10px #eee;
  margin:0;
}
</style>
